import { UserVehiclesResponse } from '../../app/features/vehicles/domain/vehicle.model';
import { getVehicleResponseMock } from './get-vehicle-response-mock';

export const userVehiclesResponseMock: UserVehiclesResponse = {
    pagination: {
        currentPage: 1,
        totalPages: 4,
        totalElements: 8,
        pageSize: 2,
    },
    data: [
        {
            ...getVehicleResponseMock,
            id: 'c7662d8a-0eaf-4127-b43c-d9e9d7657b62',
        },
    ],
};
